"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var loading_bar_service_1 = require("../../services/loading-bar.service");
/**
 * Created by Hayk.Andriasyan on 10/13/2017.
 */
var LoadingSpinnerComponent = /** @class */ (function () {
    function LoadingSpinnerComponent(loadingBarService) {
        this.loadingBarService = loadingBarService;
        this.showLoading = true;
        this._openSubscriptions = [];
    }
    LoadingSpinnerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._openSubscriptions.push(this.loadingBarService.loading().subscribe(function (isLoading) {
            _this.showLoading = isLoading;
        }));
    };
    LoadingSpinnerComponent.prototype.ngOnDestroy = function () {
        this._openSubscriptions.forEach(function (s) { return s.unsubscribe(); });
    };
    LoadingSpinnerComponent = __decorate([
        core_1.Component({
            
            selector: 'sis-loading-spinner',
            template: require('./loading-spinner.component.html'),
            styles: [require('./loading-spinner.component.css')]
        }),
        __metadata("design:paramtypes", [loading_bar_service_1.LoadingBarService])
    ], LoadingSpinnerComponent);
    return LoadingSpinnerComponent;
}());
exports.LoadingSpinnerComponent = LoadingSpinnerComponent;
//# sourceMappingURL=loading-spinner.component.js.map